<template>
  <div class="staff-form">
    <div
      class="collapse-box"
      :style="`width: calc(100% - ${visibleHistory ? historyWidth : 0}px);`"
    >
      <b-tabs v-model="currentTab" pills>
        <b-overlay :show="loading" rounded="sm" style="min-height:100px;">
          <template v-if="!loading">
            <b-tab
              v-for="tab in tabs"
              :key="tab.component"
              :title="i18n(`form.tab.${tab.component}`)"
              :active="activeTab === tab.component"
            >
              <div class="staff-form-body">
                <component
                  :is="tab.component"
                  :audit-data="
                    auditData.filter(
                      (o) => o.module == tab.field && o.status === 1
                    )
                  "
                  :data="data[tab.field]"
                  :staff-id="data.staff.id"
                  :refresh-change="refreshChange"
                  :disabled="disabled"
                  :current-tab="currentTab"
                />
              </div>
            </b-tab>
          </template>
        </b-overlay>
      </b-tabs>
      <b-button
        v-if="tabs[currentTab] && tabs[currentTab].visibleHistory"
        variant="primary"
        class="btn-icon staff-form-historyBtn"
        @click="visibleHistory = !visibleHistory"
      >
        <feather-icon icon="ClockIcon" />
      </b-button>
      <div class="staff-form-historyBtn user-info" style="right: 45px;">
        <template v-if="data.staff">
          <div>
            <p class="user-info__name text-primary">
              {{ data.staff.enName }}
            </p>
            <p class="user-info__code">
              {{ data.employment.staffNo }}
            </p>
          </div>
          <div class="ml-1">
            <b-avatar :src="data.staff.attach ? data.staff.attach.link : ''" />
          </div>
        </template>
      </div>
      <div
        v-if="tabs[currentTab]"
        class="collapse-box-right"
        :style="`right: -${historyWidth}px; width:${historyWidth}px`"
      >
        <c-history
          :visible="visibleHistory"
          :data="auditData.filter((o) => o.module == tabs[currentTab].field)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BTab, BTabs, BButton, BOverlay, BAvatar } from 'bootstrap-vue'
import { staff, infoAudit } from '@/api/staff/index'
import personal from './tabContent/personal.vue'
import employment from './tabContent/employment.vue'
import certification from './tabContent/certification.vue'
import salary from './tabContent/salary.vue'
import family from './tabContent/family.vue'
import contacts from './tabContent/contacts.vue'
import others from './tabContent/others.vue'
import projects from './tabContent/projects.vue'
import vacation from '../vacation/components/tabContent/vacation.vue'
import education from './tabContent/education.vue'
import benefit from './tabContent/benefit.vue'
import expensePercentage from './tabContent/expensePercentage.vue'
import questions from './tabContent/questions.vue'

// 记录
import CHistory from './history/index.vue'

export default {
  name: 'StaffForm',
  components: {
    BTab,
    BTabs,
    personal,
    employment,
    certification,
    salary,
    family,
    contacts,
    others,
    projects,
    CHistory,
    BButton,
    BOverlay,
    vacation,
    education,
    BAvatar,
    benefit,
    expensePercentage,
    questions,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      historyBtnShow: true,
      currentTab: 0,
      data: {},
      auditData: [],
      tabs: [
        {
          component: 'personal',
          field: 'staff',
          visibleHistory: true,
        },
        {
          component: 'education',
          field: 'infoEdu',
        },
        {
          component: 'certification',
          field: 'infoCerts',
        },
        // {
        //   component: 'salary',
        //   field: 'salary',
        // },
        {
          component: 'family',
          field: 'infoFamilies',
        },
        {
          component: 'contacts',
          field: 'infoContacts',
        },
        {
          component: 'employment',
          field: 'employment',
          visibleHistory: true,
        },
        {
          component: 'workingExperience',
          field: 'workingExperience',
        },
        {
          component: 'projects',
          field: 'projects',
        },
        {
          component: 'vacation',
          field: 'vacationInfoVOS',
        },
        {
          component: 'benefit',
          field: 'baseInfoBenefit',
        },
        {
          component: 'expensePercentage',
          field: 'expensePercentage',
        },
        {
          component: 'questions',
          field: 'staff',
        },
      ],
      activeTab: 'personal',
      visibleHistory: false,
      historyWidth: 300,
    }
  },
  computed: {},
  watch: {
    currentTab() {
      this.visibleHistory = false
    },
  },
  mounted() {
    if (this.id) {
      this.onload(this.id)
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    async onload(id, loading = true) {
      this.loading = loading
      const res = await staff.detail({ staffId: id })

      const res2 = await infoAudit.getList(1, -1, { staffId: id })
      this.auditData = res2.data.data.records
      this.data = res.data.data
      console.log('ssdddddd', this.data)
      if (this.data.employment) {
        console.log('5555555555555555555555555555555')
        this.data.employment.shift =
          this.data.employment.shift == -1 ? '' : this.data.employment.shift
      }
      this.loading = false
    },
    async refreshChange(done) {
      await this.onload(this.id, false)
      done()
    },
  },
}
</script>

<style lang="scss">
.staff-form {
  padding: 10px;
  overflow: hidden;
  height: 100%;
  display: flex;
  .nav {
    height: 50px;
    flex-wrap: nowrap;
    width: calc(100% - 265px);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .tabs {
    height: 100%;
    .tab-content {
      overflow: auto;
      height: calc(100% - 60px);
      .tab-pane {
        height: 100%;
      }
    }
  }
  &-body {
    display: block;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &-historyBtn {
    position: absolute;
    top: 0;
    right: 0;
  }
  .collapse-box {
    transition: width 0.3s;
    position: relative;
    &-right {
      position: absolute;
      height: 100%;
      top: 0;
    }
  }

  .user-info {
    background: #eee;
    border-radius: 3px;
    padding: 5px 10px;
    text-align: right;
    display: flex;
    align-items: center;
    p {
      margin: 0;
      padding: 0;
    }
    &__name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 150px;
      font-size: 16px;
    }
    &__code {
      color: #aaa;
      font-size: 12px;
    }
  }
}
</style>
